(function () {
  function updateFeaturedImage(section, thumb) {
    var featuredImage = section.querySelector('.braidjoy-product-main__featured-image');
    if (!featuredImage || !thumb) {
      return;
    }

    var src = thumb.getAttribute('data-full-src');
    var srcset = thumb.getAttribute('data-full-srcset');
    var alt = thumb.getAttribute('data-alt') || '';

    if (src) {
      featuredImage.setAttribute('src', src);
    }

    if (srcset) {
      featuredImage.setAttribute('srcset', srcset);
    }

    featuredImage.setAttribute('alt', alt);

    section.querySelectorAll('[data-braidjoy-thumb]').forEach(function (button) {
      var isActive = button === thumb;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function updateQuantity(section, nextQuantity) {
    var quantity = Math.max(1, nextQuantity);
    var quantityInput = section.querySelector('[data-braidjoy-quantity-input]');
    var quantityValue = section.querySelector('[data-braidjoy-quantity-value]');

    if (quantityInput) {
      quantityInput.value = String(quantity);
    }

    if (quantityValue) {
      quantityValue.textContent = String(quantity);
    }
  }

  function updateVariant(section, option) {
    if (!option) {
      return;
    }

    var variantInput = section.querySelector('[data-braidjoy-variant-id]');
    var price = section.querySelector('[data-braidjoy-price]');
    var addButton = section.querySelector('[data-braidjoy-add-button]');
    var addText = section.querySelector('[data-braidjoy-add-text]');
    var isAvailable = option.getAttribute('data-available') === 'true';
    var mediaId = option.getAttribute('data-media-id');

    if (variantInput) {
      variantInput.value = option.value;
    }

    if (price && option.getAttribute('data-price')) {
      price.textContent = option.getAttribute('data-price');
    }

    if (addButton) {
      addButton.disabled = !isAvailable;
    }

    if (addText) {
      addText.textContent = isAvailable ? 'Add to cart' : 'Sold out';
    }

    if (mediaId) {
      var matchingThumb = section.querySelector('[data-braidjoy-thumb][data-media-id="' + mediaId + '"]');
      if (matchingThumb) {
        updateFeaturedImage(section, matchingThumb);
      }
    }
  }

  function initSection(section) {
    if (!section || section.dataset.braidjoyProductMainInitialized === 'true') {
      return;
    }

    section.dataset.braidjoyProductMainInitialized = 'true';

    section.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-braidjoy-thumb]');
      var minus = event.target.closest('[data-braidjoy-quantity-minus]');
      var plus = event.target.closest('[data-braidjoy-quantity-plus]');

      if (thumb && section.contains(thumb)) {
        updateFeaturedImage(section, thumb);
        return;
      }

      if (minus || plus) {
        var quantityInput = section.querySelector('[data-braidjoy-quantity-input]');
        var currentQuantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
        if (Number.isNaN(currentQuantity)) {
          currentQuantity = 1;
        }

        updateQuantity(section, currentQuantity + (plus ? 1 : -1));
      }
    });

    var variantSelect = section.querySelector('[data-braidjoy-variant-select]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        updateVariant(section, variantSelect.options[variantSelect.selectedIndex]);
      });
      updateVariant(section, variantSelect.options[variantSelect.selectedIndex]);
    }

    updateQuantity(section, 1);
  }

  function initAll() {
    document.querySelectorAll('[data-braidjoy-product-main]').forEach(initSection);
  }

  function initStickyAtcVisibilityObserver() {
    if (document.body.dataset.braidjoyStickyAtcObserverInitialized === 'true') {
      return;
    }

    document.body.dataset.braidjoyStickyAtcObserverInitialized = 'true';

    var chatToggleSelector =
      'button.chat-toggle.chat-toggle--bottom-right, button[data-spec="toggle-button"].chat-toggle, .chat-toggle.chat-toggle--bottom-right';

    var isStickyAtcVisible = function () {
      var stickyCandidates = document.querySelectorAll(
        '.mu_sticky_visible, .desktopStickyCartContainar___3nN72, [class*="desktopStickyCartContainar"], .mu_sticky_descktop, .mu_sticky_mobile_atc, [class*="mu_sticky_mobile_atc"], .actionsSection___3SG34, [class*="actionsSection"]'
      );

      return Array.prototype.some.call(stickyCandidates, function (element) {
        if (!element.classList.contains('mu_sticky_visible') && !element.closest('.mu_sticky_visible')) {
          return false;
        }

        var styles = window.getComputedStyle(element);
        var rect = element.getBoundingClientRect();

        return (
          styles.display !== 'none' &&
          styles.visibility !== 'hidden' &&
          Number(styles.opacity) > 0 &&
          rect.width > 0 &&
          rect.height > 0
        );
      });
    };

    var syncStickyChatState = function () {
      var visible = isStickyAtcVisible();

      document.body.classList.toggle('sticky-atc-visible', visible);

      document.querySelectorAll(chatToggleSelector).forEach(function (button) {
        if (visible) {
          button.style.setProperty('display', 'none', 'important');
          button.style.setProperty('visibility', 'hidden', 'important');
          button.style.setProperty('opacity', '0', 'important');
          button.style.setProperty('pointer-events', 'none', 'important');
        } else {
          button.style.removeProperty('display');
          button.style.removeProperty('visibility');
          button.style.removeProperty('opacity');
          button.style.removeProperty('pointer-events');
        }
      });
    };

    var requestSync = function () {
      window.requestAnimationFrame(syncStickyChatState);
    };

    var observer = new MutationObserver(requestSync);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });

    window.addEventListener('scroll', syncStickyChatState, { passive: true });
    window.addEventListener('resize', syncStickyChatState);

    syncStickyChatState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      initStickyAtcVisibilityObserver();
    });
  } else {
    initAll();
    initStickyAtcVisibilityObserver();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target.querySelector('[data-braidjoy-product-main]'));
  });
})();
